import React from 'react';
import { Box } from '@mui/material';
import FilterChip from './FilterChip';
import { 
  ASSIGNMENT_BADGES,
  getBadgeColor,
  getBadgeTextColor,
  getBadgeBorderColor
} from '../../../constants/assignmentStatuses';

const AssignmentBadgeFilter = ({ 
  selectedBadges = [], 
  onBadgeToggle,
  sx = {} 
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', ...sx }}>
      {Object.values(ASSIGNMENT_BADGES).map((badge) => {
        const isSelected = selectedBadges.includes(badge);
        
        return (
          <FilterChip
            key={badge}
            label={badge}
            isSelected={isSelected}
            onClick={() => onBadgeToggle(badge)}
            backgroundColor={getBadgeColor(badge)}
            textColor={getBadgeTextColor(badge)}
            borderColor={getBadgeBorderColor(badge)}
            showDot={true}
          />
        );
      })}
    </Box>
  );
};

export default AssignmentBadgeFilter; 